import { GameConstants } from "../../GameConstants";

import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { BoardScene } from "./BoardScene";

export class RulesLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const tmpBackground = new Phaser.GameObjects.Graphics(this.scene);
        tmpBackground.fillStyle(0x000000, .01);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        tmpBackground.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        tmpBackground.on("pointerdown", () => {
            // 
        }, this);
        this.add(tmpBackground);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        let title = new Phaser.GameObjects.Image(this.scene, 0, -310, "texture_atlas_1", "txt_rules");
        scaledItemsContainer.add(title);

        let rulesImg = new Phaser.GameObjects.Image(this.scene, 0, 40, "texture_atlas_1", "rules");
        scaledItemsContainer.add(rulesImg);

        const playButton = new Button(this.scene, 0, 380, "texture_atlas_1", "btn_next", "btn_next_hover");
        playButton.onUp(this.onClickPlay, this);
        scaledItemsContainer.add(playButton);
    }

    public onClickPlay(): void {

        this.scene.tweens.add({
            targets: this,
            y: 1000,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            onComplete(): void {
                this.destroy();
            }, 
            onCompleteScope: this
        });
        
        BoardScene.currentInstance.onRulesRemoved();
    }
}
